import type { TPageTranslations } from '@crehana/i18n';

import { CREATE_AND_EDIT_EMAIL_TEMPLATES } from './constants';
import type { TKeys } from './types';

export const en: TPageTranslations<
  TKeys,
  typeof CREATE_AND_EDIT_EMAIL_TEMPLATES
> = {
  [CREATE_AND_EDIT_EMAIL_TEMPLATES]: {
    DAY: 'day',
    DAYS: 'days',
    SUCCESS_TITLE_CREATE_TEMPLATE: 'Template created successfully',
    TOAST_TITLE_CREATE_TEMPLATE_ERROR: 'Error creating template',
    SUCCESS_TITLE_RESET: 'Template reset successfully',
    TOAST_TITLE_RESET_ERROR: 'Error resetting template',
    RECRUITMENT: 'Recruitment',
    CONFIGURATION: 'Configuration',
    EMAIL_TEMPLATES: 'Email templates',
    TEMPLATE_DETAIL: 'Template detail',
    NEW_TEMPLATE: 'New template',
    CANCEL: 'Cancel',
    ADD_NAME_TEMPLATE: 'Add a name to the template',
    IN_DRAFT: 'In draft',
    TITLE_SCHEDULE_SHIPMENT: 'Schedule shipment',
    FIRST_DESCRIPTION_SCHEDULE_SHIPMENT:
      'Use this option to notify the candidate that they will not continue in the process one or more days after their rejection. The email will be sent only on business days (Monday to Friday).',
    SECOND_DESCRIPTION_SCHEDULE_SHIPMENT:
      '*If not activated, the shipment will be automatic after the rejection.',
    NUMBER_OF_DAYS: 'Number of days',
    SHIPPING_TIME: 'Shipping hours',
    RESTORE_TEMPLATE: 'Restore template',
    SEND_TEST_EMAIL: 'Send test email',
    SAVE_AND_EXIT: 'Save and exit',
    TITLE_RESTORE_TEMPLATE: 'Do you want to restore the template?',
    DESCRIPTION_RESTORE_TEMPLATE:
      'All changes will be lost, and the content will return to its default state.',
    YES_RESTORE: 'Yes, restore',
    LOADING_TEXT: 'Restoring...',
    TITLE_TEST_MAIL_SENDING: 'Do you want to send a test email?',
    DESCRIPTION_TEST_MAIL_SENDING: 'Remember that the email will be sent to:',
    YES_SEND: 'Yes, send',
    TITLE_UNSAVED_CHANGES: 'You have unsaved changes. Do you want to exit?',
    DESCRIPTION_UNSAVED_CHANGES: 'All changes will be lost.',
    EXIT_WITHOUT_SAVING: 'Exit without saving',
    BACK_TO_EDITING: 'No, return to editing',
    NOTIFICATION_REEMPLACE: 'Replace image',
    NOTIFICATION_IMAGE_SIZE: 'Size: 600 x 192 px, Max: 2 MB, Format: PNG, JPG',
    NOTIFICATION_LOADING: 'Loading...',
    NOTIFICATION_PROGRESS_LABEL: 'Loading image...',
    NOTIFICATION_ERROR_NUMBER_FILES:
      'You can upload up to {{MAX_FILES}} files.',
    NOTIFICATION_ERROR_SIZE: 'The file does not meet the size requirements',
    SUBJECT_EMAIL: 'Subject of the email',
    REQUIRED_SUBJECT: '(Required)',
    NOTIFICATION_SUBMIT_PLACEHOLDER: 'Enter a subject',
    PLACEHOLDER_SUBJECT_EMAIL: 'Complete field',
    UPLOAD_ATTACHMENT: 'Upload attachment',
    MAX_ATTACHMENTS_SIZE: '(Max. 3 files, max weight: 20MB)',
    NOTIFICATION_ERROR_LABEL: 'Error loading file',
    NOTIFICATION_ERROR_EXTENSION: 'The file does not meet the required format',
    NOTIFICATION_RETRY: 'Retry',
    USER_DIALOG_DELETE_BUTTON_CANCEL: 'Cancel',
    NOTIFICATION_ATTACHMENT_RETRY: 'Retry',
    FILE_SIZE_ERROR: 'The file does not meet the size requirements',
    ERROR_UPLOAD_FILE: 'Error loading file',
    NOTIFICATION_DRAG_IMAGE: 'Drag your image to load it or',
    NOTIFICATION_CHOOSE_FILE: 'choose your file',
    NOTIFICATION_TITLE_PLACEHOLDER: 'Enter a title',
    NOTIFICATION_TEXTAREA_PLACEHOLDER: 'Write the message body',
    MAX_LENGTH_TITLE: 'Maximum 58 characters',
    NAME_EMPLOYEE: '{NAME_EMPLOYEE}',
    NAME_ORGANIZATION: '{NAME_ORGANIZATION}',
    NAME_VACANCY: '{NAME_VACANCY}',
    NAME_EMPLOYEE_LABEL: 'Employee name',
    NAME_ORGANIZATION_LABEL: 'Organization name',
    NAME_VACANCY_LABEL: 'Vacancy name',
    DELETE_FILE: 'Delete',
    UPLOADING_FILE: 'Uploading file',
    SUCCESS_TITLE_SEND_TEST_EMAIL: 'The test email was sent successfully.',
    SUCCESS_DESCRIPTION_SEND_TEST_EMAIL:
      'Please check your mailbox or spam folder.',
    FILE_EXTENSION_ERROR: 'The file does not meet the required format',
    FILE_PREVIEW_ERROR: 'Error creating file preview',
    TOAST_TITLE_SEND_TEST_EMAIL_ERROR: 'Error sending test email',
    TOAST_DESCRIPTION_SEND_TEST_EMAIL_ERROR: 'Please try again later.',
    LOADING_TEXT_SEND_TEST_EMAIL: 'Sending...',
    UPLOAD_DOCUMENTS: 'Upload documents',
  },
};
